import { ColumnDef } from '@tanstack/react-table'
import { AppTable, AppTableProps, AppTypography, TableActions } from 'components'
import { getMDYFormattedDate } from 'globals/functions'
import { FC } from 'react'
import { NewsAlertViewModel } from 'sdk'

interface Props extends AppTableProps<NewsAlertViewModel> {
  onEditClick: (data: NewsAlertViewModel) => void
  onRemoveClick: (id: string) => void
}
export const NewAlertsTable: FC<Props> = ({ onEditClick, onRemoveClick, ...props }) => {
  const columns: ColumnDef<NewsAlertViewModel>[] = [
    {
      id: 'popover',
      cell: ({ row }) => (
        <TableActions
          row={row}
          actions={[
            { text: 'Edit', onClick: () => onEditClick(row.original) },
            { text: 'Delete', onClick: () => onRemoveClick(row.original.Id!) },
          ]}
        />
      ),
    },
    {
      header: 'Start Date',
      cell: ({ row }) => <AppTypography>{getMDYFormattedDate(new Date(row.original.StartDate ?? ''))}</AppTypography>,
    },
    {
      header: 'Article Date',
      cell: ({ row }) => <AppTypography>{getMDYFormattedDate(new Date(row.original.ArticleDate ?? ''))}</AppTypography>,
    },
    {
      header: 'Title',
      accessorKey: 'Title',
    },
    {
      header: 'URL',
      accessorKey: 'ArticleUrl',
    },
    {
      header: 'Created By',
      accessorKey: 'CreatedBy',
    },
  ]
  return (
    <>
      <AppTable columns={columns} {...props} />
    </>
  )
}
